import { render } from "./SystemEvaluationMetrics.vue?vue&type=template&id=61b85081&ts=true"
import script from "./SystemEvaluationMetrics.vue?vue&type=script&lang=ts"
export * from "./SystemEvaluationMetrics.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__